module.exports = __webpack_public_path__ + "media/images/dividend/img-ashley@2x-38c8c97a3e6ccffb824c6cc8a89b2da8.png";